import {gql} from '@apollo/client';

import {
  ActionPlanAdjustmentFragment,
  ActionPlanFragment as _ActionPlanFragment,
  CheckInFragment,
  HealthFactorAssessmentFragment,
} from '#apollo/schema';

/*
 * Action Plan Page Namespace
 */
export namespace ActionPlanPage {
  export interface ActionPlan extends _ActionPlanFragment {}
  export interface ActionPlanAdjustment extends ActionPlanAdjustmentFragment {}
  export interface HealthFactorAssessment extends HealthFactorAssessmentFragment {}
  export interface CheckIn extends CheckInFragment {}
  export type State =
    | 'error'
    | 'missing-lab'
    | 'missing-survey'
    | 'missing-lab-result'
    | 'missing-survey-and-lab'
    | 'high-performer'
    | 'inactive'
    | 'active'
    | 'non-member'
    | 'locked';
}

export const ActionPlanFragment = gql`
  ${ActionPlanAdjustmentFragment}
  fragment ActionPlanFragment on ActionPlan {
    id
    active
    adjustments {
      ...ActionPlanAdjustmentFragment
    }
  }
`;
